import { imprimirNotaVenda } from 'modulo-gerencial-erp-pacotes-impressora-termica';

import { imprimirServicoNovo, buscarDadosImpressao } from '../utils';

async function imprimir(id, query = '', usar_nova_impressao = true) {
  /* if (!usar_nova_impressao) {
    return await imprimirServicoAntigo(id, 1, query);
  }

  const dados = await buscarDadosImpressao(id, 1);

  const { comandos } = layout(adapter(dados), true);

  const response = await imprimirServicoNovo(id, 'venda', comandos);
  return response.data; */

  return await imprimirNotaVenda({
    id,
    buscarDadosImpressao,
    chamarServicoImpressoraTermica: imprimirServicoNovo,
    query,
  });
}

export default imprimir;
